export default "__VITE_ASSET__D27xqBE1__"